module.exports = __webpack_public_path__ + "static/media/PS-17.4bac6e49.svg";